import { QuestionElementProps } from "@/components/questionnaire/components/element.type.ts";
import { Box, HtmlViewer, Stack, Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export const TextElement = ({ element }: QuestionElementProps) => {
  const textElementSettings = element.text_settings;
  if (!textElementSettings) return null;

  return (
    <Stack gap={"2xl"}>
      {(textElementSettings.title || textElementSettings.description) && (
        <Stack gap="md">
          <Title
            header={textElementSettings.title || undefined}
            size={"md"}
            className={"wrap-break-word"}
          />
          {textElementSettings.description && (
            <HtmlViewer content={textElementSettings.description} />
          )}
        </Stack>
      )}
      {textElementSettings.text && (
        <Box>
          <HtmlViewer content={textElementSettings.text} />
        </Box>
      )}
    </Stack>
  );
};

export const TextElementResult = ({ element }: QuestionElementProps) => {
  const { t } = useTranslation();

  const textElementSettings = element.text_settings;
  if (!textElementSettings) return null;

  return (
    <>
      <Title
        header={textElementSettings.title || t("surveys:question_type_text_full")}
        size={"sm"}
        className={textElementSettings.title ? "" : "text-secondary"}
        paddingTop={true}
      />
    </>
  );
};
